import { type UseQueryResult } from '@tanstack/react-query';

import { useApiList, type ApiListResult } from '../../../lib/api/hooks.js';
import { paymentGatewayRow, type PaymentGatewayDetail, type PaymentGatewayRow } from './schemas.js';
import { paymentGateways, paymentGatewayEndpoints } from './endpoints.js';

/**
 * Reads for the Payment Gateways module.
 *
 * The list is owned by `ResourceListPage`; this hook is exported for any other
 * screen that needs the same data.
 */

export function usePaymentGateway(gatewayId: string): UseQueryResult<PaymentGatewayDetail> {
  return paymentGateways.useItem(gatewayId);
}

export function usePaymentGateways(): UseQueryResult<ApiListResult<PaymentGatewayRow>> {
  return useApiList({
    resource: 'paymentGateways',
    path: paymentGatewayEndpoints.list,
    schema: paymentGatewayRow,
    params: {},
  });
}
